import { Col, DatePicker, InputNumber, Row, Select, Switch, Tooltip } from "antd";
import CustomDateFilter from "common/components/CustomDateFilter";
import CustomSelect from "common/components/CustomSelect";
import {
  ColumnElement,
  StyledAntdModal,
  StyledAntdTable,
  StyledButton,
  StyledInput
} from "common/components/StyledElements";
import { PERMISSIONS, ROLE_CONFIG_KEYS } from "common/constants";
import APIConstants from "common/constants/APIConstants";
import { useAuthContext } from "common/contexts/AuthContext";
import useCheckAuthorization from "common/hooks/useCheckAuthorization";
import CrossIcon from "common/icons/CrossGreen.svg";
import { formatQuery } from "common/utils";
import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";

import { useMutation, useQuery } from "@tanstack/react-query";
import PaginationComponent from "common/components/PaginationComponent";
import SearchComponent from "common/components/SearchComponent";
import { EventType, ReactGATracker } from "common/utils/analyticsTracker";
import { api } from "common/utils/APIMethods";
import { MESSAGE_TYPE, showMessage } from "common/utils/message";
import i18next, { t } from "i18next";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";

const { Option } = Select;

const CustomTable = styled(StyledAntdTable)`
  
`;

const AddStyledButton = styled(StyledButton)`
  padding: 12px;
`;
const AddItemButton = styled(StyledButton)`
  direction: flex;
  justify-content: center;
  padding: 8px 16px;
  height: 40px;
`;
const ItemsTableContainer = styled.div`
  margin-top: 1px;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
`;


const ClearAllButton = styled(StyledButton)`
  padding: 12px 24px;
`;

const BackgroundContainer = styled.div`
  background-color: #f8fbfb;
  width: 100%;
  height: 93vh;
  position: relative;
`;
const MainContainer = styled.div`
  margin: 0 auto;
  padding-top: 10px;
  width: 98%;
`;

const HeaderContainer = styled.div`
  display: flex;
  column-gap: 16px;
  height: 56px;
  margin-bottom: 20px;
  @media screen and (max-width: 1279px) {
    height: 38px;
    margin-bottom: 10px;
  }
`;

const RightContainer = styled.div`
  display: flex;
  gap: 16px;
`;

const RightContainerInner = styled.div``;

const StyledSelect = styled(Select)`
  width: 200px;

  .ant-select-selector {
    height: 55px !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
    border-radius: 4px !important;
    border: 1px solid rgba(0, 87, 84, 0.1) !important;
    background: linear-gradient(180deg, #fff 0%, #f5f5f5 100%) !important;
    box-shadow: 0px 4px 6px -3px rgba(154, 188, 187, 0.6) !important;
  }
  .ant-select-arrow,
  .ant-select-clear {
    top: 80% !important;
    transform: translateY(-50%);
  }
`;

const EditImg = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 12px;
  cursor: pointer;
`;

const DeleteImg = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const AddImg = styled.img`
  width: 30px;
  height: 30px;
  cursor: pointer;
`;

const addProductModelProps = {
  centered: true,
  title: i18next.t("Add StoreInventory"),
  width: "50%",
  footer: null,
  destroyOnHidden: true
};
const updateProductModelProps = {
  centered: true,
  title: "SCM Quantity",
  width: "50%",
  footer: null,
  destroyOnHidden: true
};


const BoldText = styled.div`
  color: rgba(0, 87, 84, 0.8);
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
`;

const StyledInputNumber = styled(InputNumber)`
  outline: none;
  width: 100%;
  border-radius: 4px;
  border: 1px solid rgba(0, 87, 84, 0.5);
  background: linear-gradient(180deg, #fff 0%, #f5f5f5 100%);
  color: #2e2e2e;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  @media screen and (max-width: 1279px) {
    font-size: 12px;
  }
`;

const getURLWithSelectedMaterialTypeAndTypes = (
  selectedMaterials,
  queryParams
) => {
  let paramString = null;
  const params = new URLSearchParams(queryParams);
  if (selectedMaterials) {
      params.append("material", selectedMaterials);
  }
  paramString = params.toString();
  const baseUrl = APIConstants.getStoreInventoryRecords;

  return paramString ? `${baseUrl}?${paramString}` : baseUrl;
};

const StoreInventory = () => {

      useCheckAuthorization({
    config: ROLE_CONFIG_KEYS.graniteStoreInventory,
    permission: PERMISSIONS.read
  });

  const { authConfig, parsedRoleConfig } = useAuthContext();
  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageSize: 20
  });

  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedDates, setSelectedDates] = useState([
    dayjs().subtract(30, "days").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD")
  ]);

  const [isAddProductModelVisible, setIsAddProductModelVisible] =
    useState(false);
  const [searchText, setSearchText] = useState("");

 useEffect(() => {
    ReactGATracker(EventType.INVENTORY_SCREEN_VISITED);
  }, []);



  const fetchInventoryData = () =>
    api(
      {
        url: getURLWithSelectedMaterialTypeAndTypes(
          selectedMaterials,
          {
            query: formatQuery(searchText),
            startDate: selectedDates[0],
            endDate: selectedDates[1],
            page: pagination.currentPage,
            size: pagination.pageSize
          }
        )
      },
      authConfig
    );
  const fetchStoreMaterialTypes = () =>
    api(
      {
        url: APIConstants.getInventoryHeaders
      },
      authConfig
    );

  const { data: materialTypes = [], isLoading: isMaterialTypesLoading } =
    useQuery({
      queryKey: ["StoreInventoryMaterialTypes"],
      queryFn: fetchStoreMaterialTypes
    });

  const {
    data: storeInventoryDetails = {},
    refetch,
    isLoading
  } = useQuery({
    queryKey: [
      "storeInventoryDetails",
      pagination.currentPage,
      pagination.pageSize,
      searchText,
      selectedMaterials,
      selectedDates
    ],
    queryFn: fetchInventoryData,
    enabled: selectedDates !== null &&
      selectedDates[0] != null &&
      selectedDates[1] !== null &&
      selectedMaterials.length>0
  });
  const filteredMaterialTypes = useMemo(
    () =>
      materialTypes.map((material) => ({
        id: material.id,
        label: material.materialType
      })),
    [materialTypes]
  );
    useEffect(() => setSelectedMaterials(filteredMaterialTypes.map((type) => type.id)), [materialTypes]);

  const { mutate: mutateAddProductToInventory } = useMutation({
    mutationFn: (payload) =>
      api(
        {
          url: APIConstants.saveStoreInventoryRecords,
          method: "POST",
          body: payload
        },
        authConfig
      ),
    onSuccess: (response) => {
      setIsAddProductModelVisible(false);
      showMessage(response.message, MESSAGE_TYPE.successTranslate);
      refetch();
    },
    onError: (error) => {
      showMessage(error.message, MESSAGE_TYPE.errorTranslate);
    }
  });

  const handleCloseAddProductModel = () => {
    setIsAddProductModelVisible(false);
  };
  const handleAddProduct = (values) => {
    mutateAddProductToInventory(values);
  };

  const columns = useMemo(() => {
    const memoColumns = [
      {
        title: t("Date"),
        render: (record)=>dayjs(record.date).format("YYYY-MM-DD"),
        width: 10
      },
      {
        title: "Material Type",
        render: (inventory) => <ColumnElement data={inventory.materialType} />,
        width: "20%"
      },
      {
        title: "Material Name",
        render: (inventory) => <ColumnElement data={inventory.materialName} />,
        width: "20%"
      },
      {
        title: "Machine Name",
        render: (inventory) => <ColumnElement data={inventory.machineType} />,
        width: "20%"
      },
      {
        title: t("quantity"),
        dataIndex: "quantity",
        width: 12
      },
      {
        title: t("UOM"),
        dataIndex: "uom" ,
        width: 12
      }
    ];
    return memoColumns;
  }, [
    parsedRoleConfig,
    storeInventoryDetails
  ]);

  const tableData = storeInventoryDetails?.content?.map((productDetails) => {
    const {
      graniteInventoryHeader = {},
      materialName="",
      machineType="",
      quantity = 0,
      id,
      date
    } = productDetails;
    return {
      key: id,
      materialName,
      machineType,
      quantity,
        materialType:graniteInventoryHeader?.materialType,
        date,
        uom:graniteInventoryHeader?.unitOfMeasurement
    };
  });
  return (
    <BackgroundContainer>
      <MainContainer>
        <HeaderContainer>
          <SearchComponent
            placeholder="search by Material type / Material name / Machine name"
            searchText={searchText}
            setSearchText={setSearchText}
            pagination={pagination}
            setPagination={setPagination}
            onFocus={() => {
              ReactGATracker(EventType.INVENTORY_ON_SEARCH);
            }}
            onClear={() => {
              ReactGATracker(EventType.INVENTORY_ON_SEARCH_CLEAR);
            }}
          />
          <RightContainer>
              <Tooltip
                title="Select MateriaType"
                trigger={["hover"]}
                color="rgba(0, 0, 0, 0.70)"
                styles={{
                  body: {
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    fontFamily: "Poppins"
                  },
                  root: {
                    borderRadius: "12px"
                  }
                }}
                placement="topLeft"
              >
                <RightContainerInner>
                  <CustomSelect
                    menuTitle={t("filter MaterialType")}
                    isLoading={isMaterialTypesLoading}
                    filterData={filteredMaterialTypes}
                    selectedOption={selectedMaterials}
                    setSelectedOption={(data) => {
                      setSelectedMaterials(data);
                    }}
                    isMultiSelect
                    defaultStatuses={
                    filteredMaterialTypes.length > 0
                      ? filteredMaterialTypes.map((item) => item.id)
                      : []
                  }
                    setPagination={setPagination}
                    pagination={pagination}
                    containerStyle={{ width: 200 }}
                    type="Materials"
                  />
                </RightContainerInner>{" "}
              </Tooltip>
            <RightContainerInner>
            <CustomDateFilter
                pagination={pagination}
                setPagination={setPagination}
                selectedDates={selectedDates}
                setSelectedDates={(data) => {
                  setSelectedDates(data);
                  ReactGATracker(EventType.ALL_ORDERS_CALENDER_UPDATED);
                }}
              />
              </RightContainerInner>
              <Tooltip
                  title="Add StoreInventory"
                  trigger={["hover"]}
                  color="rgba(0, 0, 0, 0.70)"
                  styles={{
                    body: {
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                      fontFamily: "Poppins"
                    },
                    root: {
                      borderRadius: "12px"
                    }
                  }}
                  placement="topLeft"
                >
                  <StyledButton
                    type="primary"
                    onClick={() => setIsAddProductModelVisible(true)}
                  >
                    Add StoreInventory
                  </StyledButton>
                </Tooltip>
          </RightContainer>
        </HeaderContainer>
        <CustomTable
          loading={isLoading}
          columns={columns}
          scroll={{ y: "calc(65vh)" }}
          dataSource={tableData}
          pagination={{
            current: pagination.currentPage + 1,
            pageSize: pagination.pageSize,
            position: ["none", "none"]
          }}
        />
        <PaginationComponent
          pagination={pagination}
          setPagination={setPagination}
          totalElements={storeInventoryDetails?.totalElements}
          totalPages={Math.ceil(
            (storeInventoryDetails?.totalElements ?? 0) / pagination.pageSize
          )}
          heading="products"
        />
      </MainContainer>
      <StyledAntdModal
        onCancel={handleCloseAddProductModel}
        open={isAddProductModelVisible}
        closeIcon={<img width={30} height={30} src={CrossIcon} alt="close" />}
        {...addProductModelProps}
      >
        <AddProductModal
          handleAddProduct={handleAddProduct}
          authConfig= {authConfig}
        />
      </StyledAntdModal>
    </BackgroundContainer>
  );
};
const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormCol = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const FormItemInner = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const InputTitle = styled.div`
  color: rgba(0, 87, 84, 0.8);
  font-family: Poppins;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
`;

const ItemsCountTitle = styled(InputTitle)``;

const CustomStyledAntdTable = styled(StyledAntdTable)`
  .ant-table-cell {
    padding: 2px !important;
  }
`;
const CustomSwitch = styled(Switch)`
    width: 30%;
`;
const ModalInput = styled(StyledInput)`
  width: 100%;
  color: #2e2e2e;
`;
const ModalInput2 = styled(StyledInput)`
  width: 100%;
  color: #2e2e2e;
`;
const ModalStyledSelect = styled(Select)`
  width: 250px;
  @media screen and (max-width: 1279px) {
    font-size: 12px;
  }
  .ant-select-selector {
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    font-size: 14px !important;
    border-radius: 4px !important;
    border: 1px solid rgba(0, 87, 84, 0.5) !important;
    background: linear-gradient(180deg, #fff 0%, #f5f5f5 100%) !important;
  }
  .ant-select-arrow,
  .ant-select-clear {
    top: 80% !important;
    transform: translateY(-50%);
  }
`;

const StyledController = styled.div`
  position: relative;
  width: 100%;
`;

const ErrorText = styled.span`
  position: absolute;
  top: 100%;
  left: 0;
  color: red;
  font-size: 12px;
  margin-top: 5px;
`;
const StyledDatePicker = styled(DatePicker)`
  outline: none;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(0, 87, 84, 0.5);
  background: linear-gradient(180deg, #fff 0%, #f5f5f5 100%);
  color: #2e2e2e;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
  @media screen and (max-width: 1279px) {
    font-size: 12px;
  }
`;

const AddProductModal = ({ handleAddProduct, authConfig }) => {
  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: {
      date: null,
      materialType: null,
      materialName: null,
      machineName: null,
      quantity: null,
      units: null
    }
  });

  const [addedItems, setAddedItems] = useState([]);
  const [isAddingItem, setIsAddingItem] = useState(false);

  const date = watch("date");
  const materialType = watch("materialType");
  const materialName = watch("materialName");
  const quantity = watch("quantity");

  const fetchStoreMaterialTypes = () =>
    api(
      {
        url: APIConstants.getInventoryHeaders,
        params: { available: true }
      },
      authConfig
    );

  const { data: materialTypes = [], isLoading } = useQuery({
    queryKey: ["StoreInventoryMaterialTypesModal"],
    queryFn: fetchStoreMaterialTypes
  });

  const filteredMaterialTypes = useMemo(
    () =>
      materialTypes.map((m) => ({
        id: m.id,
        label: m.materialType,
        uom: m.unitOfMeasurement
      })),
    [materialTypes]
  );

  const isAddEnabled =
    date &&
    materialType &&
    materialName?.trim() &&
    quantity > 0;

  const handleAddItem = () => {
    setIsAddingItem(true);
    const values = watch();

    if (!isAddEnabled) {
      showMessage("Please fill all mandatory fields", MESSAGE_TYPE.error);
      setIsAddingItem(false);
      return;
    }

    const selectedMaterial = filteredMaterialTypes.find(
      (m) => m.id === values.materialType
    );
    const newItem = {
  graniteInventoryHeader: {
    id: selectedMaterial.id,
    materialType:selectedMaterial.label,
    unitOfMeasurement:selectedMaterial.uom
  },
  materialName: values.materialName,
  machineType: values.machineName || null,
  quantity: Number(values.quantity),
  date: dayjs(values.date).format("YYYY-MM-DDTHH:mm:ss")
};


    setAddedItems((prev) => [...prev, newItem]);

    setValue("materialType", null);
    setValue("materialName", null);
    setValue("machineName", null);
    setValue("quantity", null);
    setValue("units", null);

    showMessage("Item added successfully", MESSAGE_TYPE.success);
    setIsAddingItem(false);
  };

const onSubmit = () => {
  if (addedItems.length === 0) {
    showMessage("Please add at least one item", MESSAGE_TYPE.error);
    return;
  }

  handleAddProduct(addedItems);
};


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormContainer>
        <FormItemInner>
          <InputTitle>
            Date <span style={{ color: "red" }}>*</span>
          </InputTitle>
          <Controller
            name="date"
            control={control}
            render={({ field }) => (
              <StyledDatePicker {...field}
               placeholder="Select Date"
               disabledDate={(current) => current && current.isAfter(dayjs().endOf("day"))} 
            />
            )}
          />
        </FormItemInner>

        <FormItemInner>
          <InputTitle>
            Material Type <span style={{ color: "red" }}>*</span>
          </InputTitle>
          <Controller
            name="materialType"
            control={control}
            render={({ field }) => (
              <ModalStyledSelect
                {...field}
                placeholder="Select Material Type"
                loading={isLoading}
                onChange={(value) => {
                  field.onChange(value);
                  const mat = filteredMaterialTypes.find(
                    (m) => m.id === value
                  );
                  setValue("units", mat?.uom || "");
                }}
              >
                {filteredMaterialTypes.map((opt) => (
                  <Select.Option key={opt.id} value={opt.id}>
                    {opt.label}
                  </Select.Option>
                ))}
              </ModalStyledSelect>
            )}
          />
        </FormItemInner>

        <Row gutter={24}>
          <FormCol span={12}>
            <FormItemInner>
              <InputTitle>
                Material Name <span style={{ color: "red" }}>*</span>
              </InputTitle>
              <Controller
                name="materialName"
                control={control}
                render={({ field }) => (
                  <ModalInput {...field} placeholder="Material Name" />
                )}
              />
            </FormItemInner>
          </FormCol>

          <FormCol span={12}>
            <FormItemInner>
              <InputTitle>Machine Name</InputTitle>
              <Controller
                name="machineName"
                control={control}
                render={({ field }) => (
                  <ModalInput
                    {...field}
                    placeholder="Machine Name"
                  />
                )}
              />
            </FormItemInner>
          </FormCol>
        </Row>

        <Row gutter={24}>
          <FormCol span={12}>
            <FormItemInner>
              <InputTitle>
                Quantity <span style={{ color: "red" }}>*</span>
              </InputTitle>
              <Controller
                name="quantity"
                control={control}
                render={({ field }) => (
                  <StyledInputNumber {...field} min={0} placeholder="Quantity" />
                )}
              />
            </FormItemInner>
          </FormCol>

          <FormCol span={12}>
            <FormItemInner>
              <InputTitle>Units</InputTitle>
              <Controller
                name="units"
                control={control}
                render={({ field }) => (
                  <ModalInput {...field} readOnly placeholder="Unit of measurement"/>
                )}
              />
            </FormItemInner>
          </FormCol>
        </Row>

        <Row justify="center">
          <AddItemButton
            type="primary"
            disabled={!isAddEnabled}
            loading={isAddingItem}
            onClick={(e) => {
              e.preventDefault();
              handleAddItem();
            }}
          >
            Add
          </AddItemButton>
        </Row>

        {addedItems.length > 0 && (
          <ItemsTableContainer>
            <ItemsCountTitle>
              Added Items ({addedItems.length})
            </ItemsCountTitle>
            <CustomStyledAntdTable
              pagination={false}
              size="small"
              scroll={{ y: 150 }}
              dataSource={addedItems.map((item, idx) => ({
                ...item,
                key: idx
              }))}
              columns={[
                { title: "Date", render:(item)=> dayjs(item.date).format("D MMM, YY"), width: 100 },
                { title: "Material Type", render: (item) => item.graniteInventoryHeader?.materialType, width: 120 },
                { title: "Material Name", dataIndex: "materialName", width: 120 },
                { title: "Machine Name", dataIndex: "machineType", width: 120 },
                { title: "Quantity", dataIndex: "quantity", width: 80 },
                { title: "UOM", render: (item) => item.graniteInventoryHeader?.unitOfMeasurement, width: 80 }
              ]}
            />
          </ItemsTableContainer>
        )}

        <ActionButtonsContainer>
          <StyledButton
            type="primary"
            htmlType="submit"
            disabled={addedItems.length === 0}
          >
            Save ({addedItems.length} items)
          </StyledButton>
        </ActionButtonsContainer>

      </FormContainer>
    </form>
  );
};


export default StoreInventory;
